import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import styles from './styles'

export const TrackList = ({ className, ...rest }) => (
  <ul className={classNames(styles.trackList, className)} {...rest} />
)

TrackList.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}
